import React from 'react';
import c from 'classnames';
import InputLabel from '../../lego/InputLabel';
import s from './FormElement.scss';
/**
 * Our standard form element layout with a slot above (`label`) and below (`details`) the supplied `children`.
 */ const FormElement = ({ inputId , label , subLabel , details , isLabelHidden , className , children , noBottomSpacing =false  })=>/*#__PURE__*/ React.createElement("div", {
        className: className
    }, label && /*#__PURE__*/ React.createElement(InputLabel, {
        className: c(s['label-wrapper'], isLabelHidden && s['hidden']),
        htmlFor: inputId,
        id: `${inputId}-label`
    }, label), subLabel, children, details && /*#__PURE__*/ React.createElement("div", {
        className: s['details-wrapper']
    }, details), !details && !noBottomSpacing && /*#__PURE__*/ React.createElement("span", {
        className: s['extra-bottom-spacing']
    }));
FormElement.displayName = 'FormElement';
export default FormElement;
